import React from 'react';
import { BackpackIcon, BookOpenIcon, LifeBuoyIcon, RouteIcon, ScaleIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
const ICONS = {
  route: RouteIcon,
  book: BookOpenIcon,
  lifebuoy: LifeBuoyIcon,
  backpack: BackpackIcon,
  scale: ScaleIcon
};
type BookCoverProps = {
  kicker: string;
  title: string;
  icon: Bonus['icon'];
  accent?: string;
  className?: string;
};

/**
 * Code-drawn bonus cover in the product look: grass seen from above, a cream
 * badge with the bonus icon, the cream title and a coloured spine.
 */
export function BookCover({
  kicker,
  title,
  icon,
  accent = 'bg-willow',
  className = ''
}: BookCoverProps) {
  const Icon = ICONS[icon];
  return <div style={{
    containerType: 'inline-size'
  }} className={`cover-grass relative aspect-[3/4] overflow-hidden rounded-[6px] shadow-book ring-1 ring-black/40 ${className}`} data-id="element-72" data-mp="29hagmoz77c93">
      <span className={`absolute inset-y-0 left-0 w-[5%] ${accent}`} aria-hidden="true" data-id="element-73" data-mp="20gccm6orf4qi" />
      <span className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/50" aria-hidden="true" data-id="element-74" data-mp="19arbh1brjbpy" />
      <svg viewBox="0 0 100 100" className="absolute left-[8%] top-[14%] w-[92%] opacity-60" aria-hidden="true" data-id="element-75" data-mp="1e1raqd8cu5vm">
        <circle cx="50" cy="60" r="58" fill="none" stroke="#F5F0DC" strokeOpacity=".45" strokeWidth=".7" data-id="element-76" data-mp="zdmoiza3fc83" />
        <rect x="45" y="30" width="10" height="44" fill="none" stroke="#F5F0DC" strokeOpacity=".5" strokeWidth=".7" data-id="element-77" data-mp="14cg4cycurfbf" />
        <path d="M41 36 H59 M41 68 H59" stroke="#F5F0DC" strokeOpacity=".5" strokeWidth=".7" data-id="element-78" data-mp="1s221zhdktmhb" />
      </svg>
      <div className="relative flex h-full flex-col items-center px-[11%] pb-[9%] pt-[8%] text-center" data-id="element-79" data-mp="1wzkbp9zf45qd">
        <p className="text-[5cqw] font-semibold text-cream/85" data-id="element-80" data-mp="1j2ncak58hfxv">No-Queue Cricket</p>
        <span className="mt-[3cqw] rounded-[1.6cqw] bg-willow px-[3.4cqw] py-[1.2cqw] text-[4.4cqw] font-bold uppercase tracking-[0.08em] text-willow-ink" data-id="element-81" data-mp="1n0l5rz61eo72">
          {kicker}
        </span>
        <span className="mt-[7cqw] flex h-[24cqw] w-[24cqw] items-center justify-center rounded-full bg-cream shadow-book" data-id="element-82" data-mp="bokas2iky3iv">
          <Icon className="h-[12cqw] w-[12cqw] text-field" strokeWidth={2.2} aria-hidden="true" data-id="element-83" data-mp="2ebqwkpei0t4j" />
        </span>
        <p className="mt-auto font-display text-[9cqw] font-extrabold leading-[1.0] tracking-tight text-cream" data-id="element-84" data-mp="29cxml6yf7k94">{title}</p>
      </div>
    </div>;
}